module.exports = __webpack_public_path__ + "assets/img/logo.f68555d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pageImgs/logo.jpg
// module id = 14
// module chunks = 2 3 4 5 6 7 8